<template>
  <v-footer padless color="rgba(1, 33, 105, 1)">
    <v-col cols="12" class="text-center">
      <span class="white--text text-lg-body-1 text-sm-body-2 text-body-2">© Copyright MRT Inc. All Rights Reserved.</span>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
<style lang="scss" scoped>
</style>
